import React from "react";
import {
  Leaf, Egg, Fish, Coffee, IceCream, Flame, Store, Apple,
  Cookie, Beer, Wine, Snowflake, FlaskConical, Utensils, Cake,
  Milk, Candy, Wheat, Bean, TreePine, Droplets, Package,
  Citrus, Salad, Beef, Sprout, UtensilsCrossed,
} from "lucide-react";

// NOTE: import Globe from "lucide-react" — add to your lucide import list
import { Globe } from "lucide-react";

export interface CategoryItem {
  id: number;
  name: string;
  parentId?: number | null;
  image?: any;  
  color?: string;
  icon: React.ComponentType<{ size?: number; color?: string }>;
}

/* ======================================================
   🛒 GROCERY DOMAIN (1500xxxxx)
   Packaged, processed & ambient supermarket goods.
   Fresh produce lives in FarmCategories.
   Fast-food & restaurant food lives in FoodCategories.
   ====================================================== */

export const groceryCategories: CategoryItem[] = [
  { id: 150000001, name: "Bakery & Bread",              color: "#E67E22", icon: Wheat },
  { id: 150000002, name: "Dairy & Chilled",             color: "#FFB300", icon: Milk },
  { id: 150000003, name: "Frozen Foods",                color: "#03A9F4", icon: Snowflake },
  { id: 150000004, name: "Beverages",                   color: "#8E44AD", icon: Coffee },
  { id: 150000005, name: "Snacks & Crisps",             color: "#FF7043", icon: Cookie },
  { id: 150000006, name: "Confectionery & Sweets",      color: "#E91E63", icon: Candy },
  { id: 150000007, name: "Breakfast & Cereals",         color: "#D4A017", icon: Wheat },
  { id: 150000008, name: "Condiments & Sauces",         color: "#FF5722", icon: FlaskConical },
  { id: 150000009, name: "Canned & Tinned Goods",       color: "#009688", icon: Store },
  { id: 150000010, name: "Pasta, Rice & Noodles",       color: "#9E9E9E", icon: Utensils },
  { id: 150000011, name: "Oils, Fats & Vinegar",        color: "#F9A825", icon: Droplets },
  { id: 150000012, name: "Baking & Cooking Aids",       color: "#8D6E63", icon: Cake },
  { id: 150000013, name: "Tea, Coffee & Hot Drinks",    color: "#6D4C41", icon: Coffee },
  { id: 150000014, name: "Alcoholic Beverages",         color: "#7B1FA2", icon: Wine },
  { id: 150000015, name: "Baby & Infant Food",          color: "#F48FB1", icon: Milk },
  { id: 150000016, name: "Health & Organic Packaged",   color: "#43A047", icon: Leaf },
  { id: 150000017, name: "World & International Food",  color: "#1565C0", icon: Globe },
  { id: 150000018, name: "Deli & Ready Meals",          color: "#D32F2F", icon: UtensilsCrossed },
  { id: 150000019, name: "Spreads & Peanut Butter",    color: "#795548", icon: Cookie },
  { id: 150000020, name: "Spices & Dry Seasonings",    color: "#BF360C", icon: Flame },
];

export const grocerySubcategories: CategoryItem[] = [
  /* Bakery */
  { id: 150000101, parentId: 150000001, name: "Sliced Bread & Loaves",       icon: Wheat },
  { id: 150000102, parentId: 150000001, name: "Rolls, Buns & Bagels",        icon: Wheat },
  { id: 150000103, parentId: 150000001, name: "Cakes & Pastries (packed)",   icon: Cake },
  { id: 150000104, parentId: 150000001, name: "Crackers & Rice Cakes",       icon: Cookie },
  { id: 150000105, parentId: 150000001, name: "Wraps & Tortillas",           icon: Wheat },
  { id: 150000106, parentId: 150000001, name: "Crumpets & Waffles (packed)", icon: Cake },

  /* Dairy & Chilled */
  { id: 150000201, parentId: 150000002, name: "Milk (UHT & Pasteurised)",    icon: Milk },
  { id: 150000202, parentId: 150000002, name: "Yoghurt & Kefir",             icon: Milk },
  { id: 150000203, parentId: 150000002, name: "Butter & Dairy Spreads",      icon: Milk },
  { id: 150000204, parentId: 150000002, name: "Cheese (Packaged & Sliced)",  icon: Milk },
  { id: 150000205, parentId: 150000002, name: "Cream & Sour Cream",          icon: Milk },
  { id: 150000206, parentId: 150000002, name: "Packaged Eggs",               icon: Egg },
  { id: 150000207, parentId: 150000002, name: "Chilled Ready Meals",         icon: UtensilsCrossed },
  { id: 150000208, parentId: 150000002, name: "Deli Meats & Cold Cuts",      icon: Beef },

  /* Frozen */
  { id: 150000301, parentId: 150000003, name: "Ice Cream & Gelato",          icon: IceCream },
  { id: 150000302, parentId: 150000003, name: "Frozen Vegetables",           icon: Snowflake },
  { id: 150000303, parentId: 150000003, name: "Frozen Meat & Fish",          icon: Snowflake },
  { id: 150000304, parentId: 150000003, name: "Frozen Ready Meals",          icon: Snowflake },
  { id: 150000305, parentId: 150000003, name: "Frozen Fries & Snacks",       icon: Snowflake },
  { id: 150000306, parentId: 150000003, name: "Frozen Pizza & Bread",        icon: Snowflake },

  /* Beverages */
  { id: 150000401, parentId: 150000004, name: "Drinking Water & Sparkling",  icon: Droplets },
  { id: 150000402, parentId: 150000004, name: "Juices & Nectars",            icon: Citrus },
  { id: 150000403, parentId: 150000004, name: "Soft Drinks & Sodas",         icon: Beer },
  { id: 150000404, parentId: 150000004, name: "Energy & Sports Drinks",      icon: Flame },
  { id: 150000405, parentId: 150000004, name: "Dairy Drinks & Shakes",       icon: Milk },
  { id: 150000406, parentId: 150000004, name: "Plant-based Drinks",          icon: Leaf },

  /* Snacks */
  { id: 150000501, parentId: 150000005, name: "Crisps & Potato Chips",       icon: Cookie },
  { id: 150000502, parentId: 150000005, name: "Popcorn",                     icon: Cookie },
  { id: 150000503, parentId: 150000005, name: "Packaged Nuts & Trail Mix",   icon: TreePine },
  { id: 150000504, parentId: 150000005, name: "Biscuits & Wafers",           icon: Cookie },
  { id: 150000505, parentId: 150000005, name: "Dried Fruit Snacks",          icon: Apple },
  { id: 150000506, parentId: 150000005, name: "Pretzels & Puffs",            icon: Cookie },
  { id: 150000507, parentId: 150000005, name: "Granola Bars & Protein Bars", icon: Wheat },

  /* Confectionery */
  { id: 150000601, parentId: 150000006, name: "Chocolate Bars & Blocks",     icon: Candy },
  { id: 150000602, parentId: 150000006, name: "Sweets & Gummies",            icon: Candy },
  { id: 150000603, parentId: 150000006, name: "Mints & Chewing Gum",         icon: Candy },
  { id: 150000604, parentId: 150000006, name: "Lollipops & Hard Candy",      icon: Candy },
  { id: 150000605, parentId: 150000006, name: "Marshmallows & Jellies",      icon: Candy },

  /* Breakfast */
  { id: 150000701, parentId: 150000007, name: "Cornflakes & Puffed Cereals", icon: Wheat },
  { id: 150000702, parentId: 150000007, name: "Porridge & Oats",             icon: Wheat },
  { id: 150000703, parentId: 150000007, name: "Muesli & Granola",            icon: Wheat },
  { id: 150000704, parentId: 150000007, name: "Honey & Jam (Spreads)",       icon: Droplets },
  { id: 150000705, parentId: 150000007, name: "Pancake & Waffle Mixes",      icon: Cake },

  /* Condiments */
  { id: 150000801, parentId: 150000008, name: "Ketchup & Tomato Sauce",      icon: FlaskConical },
  { id: 150000802, parentId: 150000008, name: "Mayonnaise & Mustard",        icon: FlaskConical },
  { id: 150000803, parentId: 150000008, name: "Soy, Chilli & Hot Sauce",     icon: Flame },
  { id: 150000804, parentId: 150000008, name: "Salad Dressings & Vinaigrette",icon: FlaskConical },
  { id: 150000805, parentId: 150000008, name: "Stock Cubes & Seasoning Packets",icon: Flame },
  { id: 150000806, parentId: 150000008, name: "Cooking Sauces (Pasta, Curry)",icon: FlaskConical },

  /* Canned */
  { id: 150000901, parentId: 150000009, name: "Canned Beans & Lentils",      icon: Bean },
  { id: 150000902, parentId: 150000009, name: "Canned Tomatoes & Puree",     icon: Store },
  { id: 150000903, parentId: 150000009, name: "Canned Fish (Tuna, Sardines)",icon: Fish },
  { id: 150000904, parentId: 150000009, name: "Canned Meat (Corned Beef)",   icon: Beef },
  { id: 150000905, parentId: 150000009, name: "Canned Fruit & Veg",          icon: Apple },
  { id: 150000906, parentId: 150000009, name: "Canned Soup & Broth",         icon: Store },

  /* Pasta Rice */
  { id: 150001001, parentId: 150000010, name: "Spaghetti, Penne & Pasta",    icon: Utensils },
  { id: 150001002, parentId: 150000010, name: "Packaged Rice (Basmati/Jasmine)",icon: Wheat },
  { id: 150001003, parentId: 150000010, name: "Instant Noodles & Ramen",     icon: Utensils },
  { id: 150001004, parentId: 150000010, name: "Couscous, Quinoa & Bulgur",   icon: Wheat },
  { id: 150001005, parentId: 150000010, name: "Egg Noodles & Glass Noodles", icon: Utensils },

  /* Oils */
  { id: 150001101, parentId: 150000011, name: "Sunflower & Vegetable Oil",   icon: Droplets },
  { id: 150001102, parentId: 150000011, name: "Olive Oil & Coconut Oil",     icon: Droplets },
  { id: 150001103, parentId: 150000011, name: "Margarine & Spreads",         icon: Milk },
  { id: 150001104, parentId: 150000011, name: "Vinegar (Balsamic, White)",   icon: FlaskConical },

  /* Baking */
  { id: 150001201, parentId: 150000012, name: "Flour & Self-raising Flour",  icon: Package },
  { id: 150001202, parentId: 150000012, name: "Sugar (White, Brown, Icing)", icon: Candy },
  { id: 150001203, parentId: 150000012, name: "Baking Powder & Yeast",       icon: Sprout },
  { id: 150001204, parentId: 150000012, name: "Chocolate Chips & Cocoa",     icon: Candy },
  { id: 150001205, parentId: 150000012, name: "Vanilla & Food Coloring",     icon: FlaskConical },
  { id: 150001206, parentId: 150000012, name: "Salt & Table Condiments",     icon: Flame },

  /* Tea & Coffee */
  { id: 150001301, parentId: 150000013, name: "Black & Green Tea Bags",      icon: Coffee },
  { id: 150001302, parentId: 150000013, name: "Instant Coffee",              icon: Coffee },
  { id: 150001303, parentId: 150000013, name: "Ground & Whole Bean Coffee",  icon: Coffee },
  { id: 150001304, parentId: 150000013, name: "Hot Chocolate & Milo",        icon: Coffee },
  { id: 150001305, parentId: 150000013, name: "Herbal & Fruit Teas",         icon: Leaf },
  { id: 150001306, parentId: 150000013, name: "Chai & Spiced Tea",           icon: Flame },

  /* Alcohol */
  { id: 150001401, parentId: 150000014, name: "Beer & Lager",                icon: Beer },
  { id: 150001402, parentId: 150000014, name: "Wine (Red, White, Rosé)",     icon: Wine },
  { id: 150001403, parentId: 150000014, name: "Spirits (Whisky, Gin, Rum)",  icon: Wine },
  { id: 150001404, parentId: 150000014, name: "Cider & Hard Seltzers",       icon: Beer },
  { id: 150001405, parentId: 150000014, name: "Champagne & Prosecco",        icon: Wine },

  /* Baby */
  { id: 150001501, parentId: 150000015, name: "Baby Formula & Milk",         icon: Milk },
  { id: 150001502, parentId: 150000015, name: "Pureed Baby Food",            icon: Apple },
  { id: 150001503, parentId: 150000015, name: "Baby Cereal & Porridge",      icon: Wheat },
  { id: 150001504, parentId: 150000015, name: "Baby Snacks & Biscuits",      icon: Cookie },

  /* World Food */
  { id: 150001701, parentId: 150000017, name: "Asian Sauces & Pastes",       icon: FlaskConical },
  { id: 150001702, parentId: 150000017, name: "Latin & Caribbean Staples",   icon: Flame },
  { id: 150001703, parentId: 150000017, name: "Middle Eastern & African",    icon: Wheat },
  { id: 150001704, parentId: 150000017, name: "European Specialties",        icon: Globe },

  /* Deli */
  { id: 150001801, parentId: 150000018, name: "Chilled Ready Meals",         icon: UtensilsCrossed },
  { id: 150001802, parentId: 150000018, name: "Deli Meats & Salami",         icon: Beef },
  { id: 150001803, parentId: 150000018, name: "Pies & Quiches (Chilled)",    icon: UtensilsCrossed },
  { id: 150001804, parentId: 150000018, name: "Packaged Salads",             icon: Salad },

  /* Spreads */
  { id: 150001901, parentId: 150000019, name: "Peanut Butter (Smooth/Crunchy)",icon: Cookie },
  { id: 150001902, parentId: 150000019, name: "Nutella & Hazelnut Spreads",  icon: Cookie },
  { id: 150001903, parentId: 150000019, name: "Jam, Marmalade & Preserves",  icon: Apple },
  { id: 150001904, parentId: 150000019, name: "Honey (Packaged)",            icon: Droplets },

  /* Spices */
  { id: 150002001, parentId: 150000020, name: "Whole Spices",                icon: Flame },
  { id: 150002002, parentId: 150000020, name: "Ground Spices & Blends",      icon: Flame },
  { id: 150002003, parentId: 150000020, name: "Dried Herbs",                 icon: Leaf },
  { id: 150002004, parentId: 150000020, name: "Curry Powder & Masala",       icon: Flame },
  { id: 150002005, parentId: 150000020, name: "Pepper & Chilli Flakes",      icon: Flame },
];

export const groceryProducts: CategoryItem[] = [
  { id: 150010101, parentId: 150000101, name: "White Sliced Bread 700g",        icon: Wheat },
  { id: 150010102, parentId: 150000102, name: "Sesame Burger Buns (6-pack)",    icon: Wheat },
  { id: 150010201, parentId: 150000201, name: "Full Cream UHT Milk 1L",         icon: Milk },
  { id: 150010202, parentId: 150000202, name: "Greek Yoghurt 500g",             icon: Milk },
  { id: 150010203, parentId: 150000204, name: "Cheddar Cheese Slices 200g",     icon: Milk },
  { id: 150010301, parentId: 150000301, name: "Vanilla Ice Cream 2L",           icon: IceCream },
  { id: 150010302, parentId: 150000302, name: "Frozen Mixed Veg 500g",          icon: Snowflake },
  { id: 150010401, parentId: 150000401, name: "Still Water 1.5L",               icon: Droplets },
  { id: 150010402, parentId: 150000402, name: "Orange Juice 1L (100%)",         icon: Citrus },
  { id: 150010403, parentId: 150000403, name: "Cola 2L",                        icon: Beer },
  { id: 150010404, parentId: 150000404, name: "Energy Drink 250ml",             icon: Flame },
  { id: 150010501, parentId: 150000501, name: "Ready Salted Crisps 150g",       icon: Cookie },
  { id: 150010601, parentId: 150000601, name: "Milk Chocolate Bar 100g",        icon: Candy },
  { id: 150010701, parentId: 150000701, name: "Cornflakes 500g",                icon: Wheat },
  { id: 150010702, parentId: 150000702, name: "Rolled Oats 1kg",                icon: Wheat },
  { id: 150010801, parentId: 150000801, name: "Tomato Ketchup 500ml",           icon: FlaskConical },
  { id: 150010802, parentId: 150000802, name: "Mayonnaise 400g",                icon: FlaskConical },
  { id: 150010901, parentId: 150000901, name: "Canned Kidney Beans 400g",      icon: Bean },
  { id: 150010902, parentId: 150000903, name: "Canned Tuna in Brine 160g",     icon: Fish },
  { id: 150011001, parentId: 150001001, name: "Spaghetti 500g",                 icon: Utensils },
  { id: 150011002, parentId: 150001003, name: "Instant Noodles Chicken 85g",   icon: Utensils },
  { id: 150011301, parentId: 150001301, name: "Black Tea Bags x100",            icon: Coffee },
  { id: 150011302, parentId: 150001302, name: "Instant Coffee Jar 200g",        icon: Coffee },
  { id: 150011401, parentId: 150001401, name: "Lager Beer 330ml (6-pack)",      icon: Beer },
  { id: 150011402, parentId: 150001402, name: "Red Wine Bottle 750ml",          icon: Wine },
  { id: 150011901, parentId: 150001901, name: "Smooth Peanut Butter 400g",      icon: Cookie },
  { id: 150011902, parentId: 150001902, name: "Chocolate Hazelnut Spread 400g", icon: Cookie },
];

export const groceryUnits = [
  { id: 15009001, name: "Per kg" },
  { id: 15009002, name: "Per 500 g" },
  { id: 15009003, name: "Per 250 g" },
  { id: 15009004, name: "Per litre" },
  { id: 15009005, name: "Per 500 ml" },
  { id: 15009006, name: "Per pack" },
  { id: 15009007, name: "Per piece" },
  { id: 15009008, name: "Per dozen" },
  { id: 15009009, name: "Per tray" },
  { id: 15009010, name: "Per crate" },
  { id: 15009011, name: "Per 100 g" },
  { id: 15009012, name: "Per bottle" },
];

export const groceryVariants = [
  { id: 15009101, name: "Regular" },
  { id: 15009102, name: "Organic" },
  { id: 15009103, name: "Gluten-free" },
  { id: 15009104, name: "Vegan" },
  { id: 15009105, name: "Sugar-free" },
  { id: 15009106, name: "Low-fat" },
  { id: 15009107, name: "Full-fat" },
  { id: 15009108, name: "Imported" },
  { id: 15009109, name: "Own-brand / Value" },
  { id: 15009110, name: "Family size" },
];

export const renderGroceryIcon = (
  Icon: React.ComponentType<{ size?: number; color?: string }>,
  color = "#555",
  size = 22
) => <Icon size={size} color={color} />;